<div class="table-section">
    <app-approved-forms-list></app-approved-forms-list>
</div>